import React from "react";
import { TextField, FlatButton, RaisedButton } from "material-ui";

import Label from "./label.jsx";

class OrderableTextFieldList extends React.Component {
  constructor(props) {
    super(props);
    this.addNew = this.addNew.bind(this);
    this.update = this.update.bind(this);
    this.shiftPosition = this.shiftPosition.bind(this);
  }

  static get defaultProps() {
    return {
      fields: []
    };
  }

  addNew() {
    let fields = this.props.fields;
    fields.push("");
    this.props.onChange(fields);
  }

  update(i, value) {
    let fields = this.props.fields;
    fields[i] = value;
    this.props.onChange(fields);
  }

  delete(i) {
    let fields = this.props.fields;
    fields.splice(i, 1);
    this.props.onChange(fields);
  }

  shiftPosition(index, direction) {
    let fields = this.props.fields;
    fields.splice(index + direction, 0, fields.splice(index, 1)[0]);
    this.props.onChange(fields);
  }

  render() {
    let { label, addLabel, fields } = this.props;

    return (
      <div>
        {label ? (
          <Label style={{ marginTop: 20, marginBottom: -10 }}>{label}</Label>
        ) : null}
        <ul style={{ paddingLeft: 30 }}>
          {fields.map((f, i) => {
            return (
              <li key={i}>
                <TextField
                  name={`${label}_${i}-textfield`}
                  value={f}
                  onChange={e => this.update(i, e.target.value)}
                />
                <FlatButton
                  label="▲"
                  style={{ minWidth: 30, marginLeft: 7 }}
                  labelStyle={{ padding: 0 }}
                  disabled={i === 0}
                  onTouchTap={() => this.shiftPosition(i, -1)}
                />
                <FlatButton
                  label="▼"
                  style={{ minWidth: 30 }}
                  labelStyle={{ padding: 0 }}
                  disabled={i === fields.length - 1}
                  onTouchTap={() => this.shiftPosition(i, 1)}
                />
                <FlatButton
                  label="×"
                  style={{ minWidth: 30 }}
                  labelStyle={{ padding: 0 }}
                  onTouchTap={() => this.delete(i)}
                />
              </li>
            );
          })}
        </ul>
        <RaisedButton
          label={addLabel || "Add"}
          style={{ marginLeft: "1em" }}
          onTouchTap={this.addNew}
        />
      </div>
    );
  }
}

export default OrderableTextFieldList;



// WEBPACK FOOTER //
// ./src/app/components/partials/orderable-text-field-list.jsx